import { render } from "./PaymentStatus.vue?vue&type=template&id=644b1221&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"

import "./PaymentStatus.vue?vue&type=style&index=0&id=644b1221&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644b1221"]])

export default __exports__